import { createApiHooks } from './createApiHook';
import { createApiQueries, createApiQueriesClient, createApiUseQueries } from './createApiQuery';
import { createApiFetchClient, createApiConfigQueryHashMap, getQueryHashKey } from '../../apis-infra';
import { createApiClientProvider } from './createApiClientProvider';
import { useApisClientContext } from '../Providers';
import { useIsApiFetching } from './useIsApiFetching';
import { createApiFetchHooks } from './createApiFetchHook';
import { invalidateQueries } from './createApiQueryOptions';
export function createApiClient(apiConfig) {
  const fetchApi = createApiFetchClient(apiConfig);
  const hooks = createApiHooks({
    apiConfig
  });
  const fetchHooks = createApiFetchHooks({
    apiConfig
  });
  const apiQueries = createApiQueries({
    apiConfig
  });
  const queriesClient = createApiQueriesClient({
    apiConfig,
    apiQueries
  });
  const useQueries = createApiUseQueries({
    apiQueries
  });
  const Provider = createApiClientProvider(apiConfig);
  const useHttpClient = () => useApisClientContext().httpClient;
  const useIsFetching = function () {
    for (var _len = arguments.length, methods = new Array(_len), _key = 0; _key < _len; _key++) {
      methods[_key] = arguments[_key];
    }
    return useIsApiFetching(apiConfig, ...methods);
  };
  const queryKeyToMethodName = createApiConfigQueryHashMap(apiConfig);
  const getMethodFromQuery = query => {
    const methodName = queryKeyToMethodName[getQueryHashKey(query.queryKey)];
    return methodName ? apiConfig[methodName] : undefined;
  };
  const invalidate = function () {
    for (var _len2 = arguments.length, methods = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      methods[_key2] = arguments[_key2];
    }
    const methods_ = methods != null ? methods : Object.keys(methods);
    invalidateQueries(...methods_.map(method => apiConfig[method]));
  };
  return {
    fetch: fetchApi.fetch,
    query: apiQueries,
    hooks,
    fetchHooks,
    useQueries,
    queries: queriesClient,
    Provider,
    useHttpClient,
    useIsFetching,
    getMethodFromQuery,
    invalidate
  };
}
//# sourceMappingURL=createApiClient.js.map